import React from 'react';
import styles from './Maintheme.module.css';

const Maintheme = () => {
    return (
        <div>
            Main Tmeme component (Portfolio)
        </div>
    )
}

export default Maintheme;